export type SimulatorMetrics = {
    player: string;
    level: {
        id: string;
        cardsInPlay: number;
        cardsInStack: number;
        wildcards: number;
        modifiers: number;
    };
    result: {
        attempts: number;
        wins: number;
        score?: SimulatorMetricValue;
        plus5Booster?: SimulatorMetricValue;
    };
    attempts: SimulatorLevelMetrics[];
};

export type SimulatorMetricValue = {
    min: number;
    max: number;
    average: number;
    median: number;
};

export type SimulatorLevelMetrics = {
    stackCardsRemaining: number;
    score: number;
    stars: number;
    totalMatches: number;
    totalStreaks: number;
    longestStreak: number;
    totalFolds: number;
    totalFoldStreaks: number;
    longestFoldStreak: number;
    plus5BoostersPurchased: number;
    coinsSpent: number;
    result: 'complete' | 'fail';
};

export function getEmptySimulatorLevelMetrics(): SimulatorLevelMetrics {
    return {
        stackCardsRemaining: 0,
        score: 0,
        stars: 0,
        totalMatches: 0,
        totalStreaks: 0,
        longestStreak: 0,
        totalFolds: 0,
        totalFoldStreaks: 0,
        longestFoldStreak: 0,
        plus5BoostersPurchased: 0,
        coinsSpent: 0,
        result: 'fail',
    };
}

export function calculateFinalValue(
    wins: SimulatorLevelMetrics[],
    value: keyof Omit<SimulatorLevelMetrics, 'result'>
): SimulatorMetricValue {
    const metrics: SimulatorMetricValue = {
        min: Number.MAX_SAFE_INTEGER,
        max: 0,
        average: 0,
    } as SimulatorMetricValue;

    wins.forEach((win) => {
        const v = win[value];
        metrics.min = Math.min(metrics.min, v);
        metrics.max = Math.max(metrics.max, v);
        metrics.average += v;
    });

    metrics.average /= wins.length;

    wins.sort((a, b) => a[value] - b[value]);
    metrics.median = wins[Math.floor(wins.length / 2)][value];

    return metrics;
}